import {
    BRINDE_AGUARDANDO,
    BRINDE_ENTRADA_MODO,
    BRINDE_SAIDA_MODO,
    BRINDE_ENTRADAS,
    BRINDE_SAIDAS,
    BRINDE_ESTOQUE,
    BRINDE_OPCOES
} from './brindeActions';

const INITIAL_STATE = {
    aguardando: false,
    modoEntrada: 'lista',
    modoSaida: 'lista',
    registroEntrada: {},
    registroSaida: {},
    entradas: [],
    saidas: [],
    estoque: [],
    fornecedores: [],
    clientes: [],
    representantes: [],
    brindes: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case BRINDE_AGUARDANDO:
            return { ...state, aguardando: action.payload };
        case BRINDE_ENTRADA_MODO:
            return {
                ...state,
                modoEntrada: action.payload.modo,
                registroEntrada: action.payload.registro || {}
            };
        case BRINDE_SAIDA_MODO:
            return {
                ...state,
                modoSaida: action.payload.modo,
                registroSaida: action.payload.registro || {}
            };
        case BRINDE_ENTRADAS:
            return { ...state, entradas: action.payload || [] };
        case BRINDE_SAIDAS:
            return { ...state, saidas: action.payload || [] };
        case BRINDE_ESTOQUE:
            return { ...state, estoque: action.payload || [] };
        case BRINDE_OPCOES:
            return { ...state, ...(action.payload || {}) };
        default:
            return state;
    }
};
